import { Shark } from "shark-mvc";

import templateContent from "Templates/views/refuel-edit.html";
import { refuelManager } from "../managers/refuelManager";
import { loginView } from "./loginView";
import { vehicleManager } from "../managers/vehicleManager";
import moment from "moment";
import { mainNavComponent } from "../../components/mainNav/mainNavComponent";

var refuelEditView = Shark.createJaw("refuelEditView");

refuelEditView.templateContent = templateContent;
refuelEditView.route = "rifornimento";

refuelEditView.addMethod("cancelBtn_clickHandler", function () {
	if (confirm("Sei sicuro di voler annullare? Se clicchi ok perderai le informazioni inserite.")) {
		Shark.openPage(refuelEditView);
	}
});

refuelEditView.addMethod("beforeLoad", function () {
	const currRefuel =  Shark.getInstance("Refuel", {
		datetime: moment(),
		driverId: Shark.get("currDriver").id
	});
	console.log(currRefuel, Shark.get("currDriver"))
	Shark.set("currRefuel", currRefuel);
	const vehicleList = Shark.get("vehicleList");

	if (vehicleList.length === 0) {
		vehicleManager.getList();
	}
});

refuelEditView.addMethod("init", function () {
	Shark.set("vehicleList", Shark.get("vehicleList") || []);
	this.addComponents([mainNavComponent]);
});

refuelEditView.addMethod("logOutBtn_clickHandler", function () {
	if (confirm("Sei sicuro di voler uscire?")) {
		localStorage.removeItem("sessionToken");
		localStorage.removeItem("currDriver");
		Shark.openPage(loginView);
	}
});

// refuelEditView.addMethod("keepDefaultValue_blurHandler", function (event) {
// 	const field = event.currentTarget;
// 	if (field.value.trim() === "") {
// 		field.value = this.get("lastValue");
// 	}
// });

refuelEditView.addMethod("keepDefaultValue_focusHandler", function (event) {
	const field = event.currentTarget;
	// this.set("lastValue", field.value);

	// // field.value = "";
	field.select();
});

refuelEditView.addMethod("refuelManager_savedHandler", function () {
	alert("Rifornimento salvato correttamente!");
	Shark.openPage(refuelEditView);
});

refuelEditView.addMethod("saveBtn_clickHandler", function () {
	const currRefuel = Shark.get("currRefuel");
	const isValid = currRefuel.validate();

	if (!isValid) {
		const errorsList = currRefuel.__errors.map(item => item.label).join("\n");
		alert(`Attenzione, si sono verificati i seguenti errori:\n${errorsList}`);

		return;
	}

	refuelManager.save(currRefuel);
});

Shark.registerView(refuelEditView);

export { refuelEditView };
